import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './style.module.scss';
const PageFooter = () => {
    return (_jsxs("p", { className: styles.footerContent, children: ["Beey live version ", VERSION, " \u00A9 2022-", BUILD_YEAR, " Beey by ", ' ', _jsx("a", { href: "http://www.newtontech.net", target: "_blank", rel: "noreferrer", children: "Newton Technologies" })] }));
};
export default PageFooter;
